module.exports = __webpack_public_path__ + "static/bar1-6ba0aaba76748ca476dacb05eab42e27.png";